import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import {
  Box,
  Flex,
  Heading,
  Icon,
  IconButton,
  Link,
  VStack
} from '@chakra-ui/react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { MenuItem, menuItems } from './utils/MenuItems';

const SideMenu = ({ menuItem }: { menuItem: MenuItem }) => {
  const [isOpen, setIsOpen] = useState(true);

  const location = useLocation();

  const currentPath = location.pathname;

  return (
    <Box key={menuItem.title} aria-label="items-set" w="100%">
      <Flex alignItems="center">
        <Icon as={menuItem.icon} />
        <Heading fontSize=".9rem" ml="11px" color="#001E64" textAlign="left">
          {menuItem.title}
        </Heading>
        <IconButton
          _focus={{ boxShadow: 'none' }}
          _hover={{ background: 'transparent' }}
          _active={{ background: 'transparent' }}
          icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          aria-label="Expandir"
          variant="ghost"
          onClick={() => setIsOpen(!isOpen)}
        />
      </Flex>
      {isOpen && (
        <VStack mt="4px" alignItems="start">
          {menuItem.subItems.map((subitem) => (
            <Box
              key={subitem.id}
              w="100%"
              pl="28px"
              position="relative"
              sx={{
                '&::after': {
                  content: '""',
                  height: '100%',
                  width: '5px',
                  background: '#146CFA',
                  position: 'absolute',
                  right: '-14px',
                  top: 0,
                  borderRadius: '5px 0 0 5px',
                  display: currentPath === subitem.href ? 'block' : 'none'
                }
              }}
            >
              <Link
                fontSize=".9rem"
                fontWeight={currentPath === subitem.href ? 'bold' : 'normal'}
                href={subitem.href}
                color={currentPath === subitem.href ? '#146CFA' : '#001E64'}
                mt="10px !important"
                mb="10px !important"
              >
                {subitem.title}
              </Link>
            </Box>
          ))}
        </VStack>
      )}
    </Box>
  );
};

export const WhiteLabelMenu = (): JSX.Element => {
  return (
    <Box w="100%" maxW="25vw" bg="#F8F8F8" h="100%" p="14px" pt="20px">
      <VStack alignItems="start" gap="30px" minH="calc( 100vh - 89px )">
        <Heading fontSize="1rem" color="#001E64" textAlign="left" w="100%">
          Painel
        </Heading>
        {menuItems.map((item) => (
          <SideMenu key={item.id} menuItem={item} />
        ))}
      </VStack>
    </Box>
  );
};
